import { defineStore } from 'pinia'
import { ref } from 'vue'
import MiiaFwConfig from '@/configs/config'
import { getEmergencyInspectionResult } from '@/api/emergencyInspectionResult/emergencyInspectionResultApiGwFuncs'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { GlobalError } from '@/utils/globalError/globalError'
import type { ResultSummary } from '@/types/api/emergencyInspectionResult/emergencyInspectionResult'

/** 応急危険度判定用store */
export const useEmergencyInspectionResultStore = defineStore('emergencyInspectionResult', () => {
  /** 応急危険度判定結果 */
  const emergencyInspectionResult = ref<ResultSummary | null>(null)

  /**
   * 調査実施結果取得
   * @param govCode 自治体ID
   * @param assessmentId 調査ID
   * @returns なし
   */
  const fetchAndSetEmergencyInspectionResult = async (
    govCode: string,
    assessmentId: string
  ): Promise<void> => {
    const param = {
      system: MiiaFwConfig.config.sysId,
      govCode,
      assessmentId: assessmentId
    }

    try {
      const res = await getEmergencyInspectionResult(param)
      // 取得できなかった場合は空オブジェクトが返ってくる
      emergencyInspectionResult.value = Object.keys(res.result).length > 0 ? res.result : null
    } catch (err) {
      console.error(err)
      throw new GlobalError([ERROR_CODES.EMERGENCY_INSPECTION_INFO_FETCH_FAILED])
    }
  }

  /**
   * 全てのstateを初期化
   * @param なし
   * @returns なし
   */
  const reset = (): void => {
    emergencyInspectionResult.value = null
  }

  return {
    emergencyInspectionResult,
    fetchAndSetEmergencyInspectionResult,
    reset
  }
})
